// node modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import Tooltip from 'rc-tooltip';
import Menu, { MenuItem } from 'rc-menu';

// app modules: components
import Button from 'components/Button';
import Icon from 'components/Icon';

// app modules: props
import SortingOptionsProps from 'components/SortingOptions/SortingOptionsProps';

// app modules: services
import history from 'services/history';

// app modules: constants
import { COLOURS } from 'constants/index';

// assets
import CssHeading from 'components/Heading/Heading.scss';
import CssSortingOptions from './SortingOptions.scss';

class SortingOptions extends PureComponent {
  static propTypes = {
    selected: SortingOptionsProps.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        label: PropTypes.string,
        direction: PropTypes.string,
        path: PropTypes.string,
      }),
    ).isRequired,
    className: PropTypes.string,
    sortingOptionClickHandler: PropTypes.func,
    zIndex: PropTypes.number,
  };

  static defaultProps = {
    className: '',
    sortingOptionClickHandler: null,
    zIndex: 3,
  };

  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
    };

    this.bound = {
      handleButtonClick: this.handleButtonClick.bind(this),
    };
  }

  handleMenuItemClick = option => {
    if (this.props.sortingOptionClickHandler) {
      this.props.sortingOptionClickHandler(option);
    } else {
      history.push(option.path, option.state);
    }
    this.setState({ menuOpen: false });
  };

  sortOptionsOverlay() {
    const { options, selected } = this.props;

    const actions = options.map(option => (
      <MenuItem
        key={`${option.key}-${option.direction}`}
        onClick={() => this.handleMenuItemClick(option)}
      >
        {option.label}
      </MenuItem>
    ));

    return (
      <Menu selectable={false} selectedKeys={[`${selected.orderBy}-${selected.orderByDirection}`]}>
        {actions}
      </Menu>
    );
  }

  handleButtonClick() {
    const { menuOpen } = this.state;
    this.setState({ menuOpen: !menuOpen });
  }

  render() {
    const { menuOpen } = this.state;
    const { options, selected, className, zIndex } = this.props;
    const currentOption =
      options.find(
        // eslint-disable-next-line eqeqeq
        option => option.key === selected.orderBy && option.direction == selected.orderByDirection,
      ) || options[0];
    return (
      <div className={`sorting-options ${className}`}>
        <header className="sorting-options__header">
          <div className="heading heading--size-18">Sort by:</div>
        </header>

        <Tooltip
          defaultVisible={false}
          visible={menuOpen}
          mouseEnterDelay={0.75}
          placement="bottom"
          overlayClassName="rc-tooltip--plain"
          overlay={this.sortOptionsOverlay()}
          overlayStyle={{ zIndex }}
        >
          <Button
            themeName="energized"
            size="large"
            themeType="clear"
            title={currentOption.label}
            onClick={this.bound.handleButtonClick}
          >
            {currentOption.label}&nbsp;
            <Icon
              fill={COLOURS.ENERGIZED}
              name={menuOpen ? 'caret' : 'caret-down'}
              height="14"
              width="14"
              mr={5}
            />
          </Button>
        </Tooltip>
      </div>
    );
  }
}

export default withStyles(CssSortingOptions, CssHeading)(SortingOptions);
